import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { useState as F, useEffect as I } from "react";
import t from "./index.es5701.js";
import U from "classnames";
import { FileUploadLoader as v } from "./index.es5702.js";
import { Link as $ } from "./index.es68.js";
import { UtilityErrorIcon as E } from "./index.es449.js";
import { BodyText as m } from "./index.es505.js";
const r = "file input", _ = ({
  fileName: e,
  isError: n,
  onRemoveFile: p,
  onReplace: d,
  isDisabled: i
}) => {
  const [a, c] = F(!1), f = U(t.file, {
    [t.finishedUploadingFile]: a
  }), h = (l) => {
    p(l, e);
  }, u = () => {
    c(!0);
  };
  return I(() => {
    c(!1);
  }, [e]), /* @__PURE__ */ s("div", { className: f, children: [
    /* @__PURE__ */ o("div", { className: t["file-item"], children: /* @__PURE__ */ o(
      m,
      {
        element: "p",
        size: "small",
        variant: "semi-bold",
        isEllipsis: !0,
        color: i ? "disabled" : "primary",
        testId: `${r}-file-name-${e}`,
        children: e
      }
    ) }, e),
    /* @__PURE__ */ s("div", { className: t["file-footer"], children: [
      /* @__PURE__ */ o(v, { isError: n, onFinishedUpload: u }),
      /* @__PURE__ */ s("div", { className: t["file-actions"], children: [
        !i && d && a && /* @__PURE__ */ o(
          $,
          {
            disabled: i,
            onClick: (l) => {
              l.stopPropagation(), d();
            },
            testId: `${r}-replace-${e}`,
            children: "Replace"
          }
        ),
        !i && /* @__PURE__ */ o(
          "button",
          {
            disabled: i,
            className: t["clear-button"],
            onClick: h,
            "aria-label": "remove file button",
            "data-testid": `${r}-remove-${e}`,
            children: /* @__PURE__ */ o(E, {})
          }
        )
      ] })
    ] }),
    n && /* @__PURE__ */ o(m, { color: "error", testId: `${r}-error-${e}`, children: "File upload failed" })
  ] });
};
export {
  r as DEFAULT_FILE_INPUT_TESTID,
  _ as FileUploadItem
};
//# sourceMappingURL=index.es841.js.map
